import React from 'react';
import { Routes, Route } from 'react-router-dom';
import VerifyEmail from './pages/VerifyEmail';
import Landing from './pages/Landing';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import FAQ from './pages/FAQ';
import { LanguageProvider } from './i18n/i18n';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Routes>
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/" element={<Landing />} />
        </Routes>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
